












































































































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import CountCardSimpleGrid from '@/components/count-card/simple-grid.vue';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import { Getter } from 'vuex-class';
import moment from 'moment';
// import { DEFAULT_DATE_FORMAT } from '@root/common/config'
import { DEVICE_LIST_EDIT, DEVICE_LIST_CREATE, DEVICE_LIST_DETAIL } from '../router-names';
// import { debounce } from 'lodash'
import * as _ from 'lodash';

import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';
// axios请求
import { queryDeviceList, exportDeviceList, forbidDeviceList } from '@/api/parking-lot-management/index';
import Utils from '@root/utils/common';
// 字典
import {
  dictDeviceTypeMap,
  dictDeviceStatusMap,
  dictEquipmentStatusModeMap,
  dictUnitTypeMap
} from '../../../types/parking-lot-management/dictionaries';

@Component({
  name: 'DeviceList',
  components: {
    ParkingLotSearch,
    CountCardSimpleGrid
  }
})
// @Component
export default class DeviceList extends Mixins(TableMixin, TableWidthMixin) {
  // queryDeviceListDebounce: any = function() {} // 列表防抖请求
  parkId = ''; // 车场ID,多个车场ID逗号分隔
  parkIds = [];
  areaName = ''; // 区域名称
  channelName = ''; // 通道名称
  deviceType = ''; // 设备类型
  deviceCode = ''; // 设备编号
  mode = '';
  deviceStatus = ''; // 运行状态
  deviceName = ''; //设备名称
  tableLoading: boolean = false;
  tableData: any[] = []; // 表数据
  countCardsData: any[] = []; // 统计数据
  current = 1;
  pageSize = 10;
  bisableEnableButton = '禁用';
  // 设备状态
  // @ts-ignore
  equipmentStatusOptions: IOption[] = Utils.toLabelVal(dictEquipmentStatusModeMap);
  // 设备类型下拉框
  @Getter('dictionaries/deviceType')
  deviceTypeMap?: object;
  get deviceTypeOptions(): any[] {
    return Utils.toLabelVal(this.deviceTypeMap);
  }
  // deviceTypeOptions: IOption[] = Utils.toLabelVal(dictDeviceTypeMap)
  // 设备型号
  @Getter('dictionaries/deviceMode')
  deviceModeMap?: object;
  get unitTypeOptions(): any[] {
    return Utils.toLabelVal(this.deviceModeMap);
  }
  // 运行状态选项
  deviceStatusOptions: any[] = Utils.toLabelVal(dictDeviceStatusMap);
  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '设备名称',
        dataIndex: 'deviceName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '设备状态',
        dataIndex: 'deviceStatus',
        width: 120,
        scopedSlots: { customRender: 'deviceStatus' }
      },
      {
        title: '所属车场',
        dataIndex: 'parkName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '设备类型',
        dataIndex: 'deviceType',
        width: 160,
        customRender: (text: any) => text || '其他'
      },
      {
        title: '设备品牌',
        dataIndex: 'brand',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '设备IP',
        dataIndex: 'ip',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '设备Port',
        dataIndex: 'port',
        width: 110,
        customRender: (text: any) => text || '--'
        // customRender: (text: any) => dictDeviceTypeMap[text],
      },
      {
        title: '设备型号',
        dataIndex: 'mode',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse' }
      },

      {
        title: '是否支持万能语音',
        dataIndex: 'isSupportTts',
        width: 80,
        customRender: (text: any) => text || '--'
      },
      {
        title: '使用状态',
        dataIndex: 'status',
        width: 110,
        // customRender: (text: any) => dictDeviceStatusMap[text],
        scopedSlots: { customRender: 'status' }
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 120,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }

  // 使用状态切换
  // value: string = ''
  // onChange(e: any) {
  //   console.log('radio checked', e.target.value)
  // }

  /**
   * dom展示在线状态中文
   */
  // getDeviceStatusText(value: string) {
  //   return dictDeviceStatusMap[value]
  // }
  // 生命周期初始化表单列表
  created() {
    this.fetchTableData();
  }
  // async mounted() {
  //   this.queryDeviceListDebounce = _.debounce(this.queryDeviceList, 2000)
  //   this.queryDeviceList()
  // }

  /**
   * 请求数据列表
   */
  async fetchTableData(isRefresh?: boolean) {
    if (this.tableLoading) return;
    this.tableLoading = true;
    if (isRefresh) this.current = 1;
    try {
      const { status, code, msg, data } = await queryDeviceList({
        parkId: this.parkIds.join(','),
        deviceName: this.deviceName,
        deviceType: this.deviceType,
        mode: this.mode,
        deviceStatus: this.deviceStatus,
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { datas, totalNum, totalPage, currPage, pageSize, total } = data;
      if (status === '9999') {
        this.tableData = datas;
        this.total = totalNum - 0;
        this.current = currPage - 0;
        this.pageSize = pageSize - 0;
        // @ts-ignore
        this.totalPage = totalPage - 0;
        this.countCardsData = [
          {
            title: '总设备数(个)',
            count: total.totalNum || 0,
            countColor: 'primary'
          },
          {
            title: '在线设备数(个)',
            count: total.onlineNum || 0,
            countColor: 'success'
          },
          {
            title: '离线设备数(个)',
            count: total.offlineNum || 0,
            countColor: 'gray'
          },
          {
            title: '异常设备数(个)',
            count: total.exceptionNum || 0,
            countColor: 'error'
          }
        ];
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.tableLoading = false;
    }
  }
  //搜索
  searchTableData() {
    this.fetchTableData(true);
  }
  // 清除搜索条件
  clear({ defaultParkIdList }) {
    this.parkId = '';
    this.parkIds = defaultParkIdList;
    this.deviceName = '';
    this.deviceType = '';
    this.mode = '';
    this.deviceStatus = '';
    this.fetchTableData(true);
  }
  // 编辑跳转
  toUpdate(deviceId: string) {
    this.$router.push({
      name: DEVICE_LIST_EDIT,
      params: {
        deviceId
      }
    });
  }
  // 新增跳转
  toCreate() {
    this.$router.push({
      name: DEVICE_LIST_CREATE
    });
  }
  // 详情跳转
  toDetail(deviceId: string) {
    this.$router.push({
      name: DEVICE_LIST_DETAIL,
      params: {
        deviceId
      }
    });
  }
  // 点击发起启用禁用请求弹出事件
  async disableEnabled(row: any) {
    const { deviceId } = row;
    // row.status === '失效' ? '01' : '00'
    const { code, status, msg, data } = await forbidDeviceList({
      deviceId,
      status: row.status === '失效' ? '01' : '00'
    });
    if (status === '9999') {
      this.$message.success('操作成功');
      this.fetchTableData();
    } else {
      this.$message.error(msg);
    }
  }

  /**
   * 导出
   */
  // async handleExport() {
  //   try {
  //     const { status, code, msg, data } = await exportDeviceList(this.filterParam)
  //     // 成功
  //   } catch (error) {
  //     console.log('queryParkList error')
  //   }
  // }
}
